
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"グループ 229","transform":"translate(-3546 886)"}},[_c('circle',{attrs:{"data-name":"楕円形 6","cx":"16","cy":"16","r":"16","transform":"translate(3546 -886)","fill":"#4756a6"}}),_c('path',{attrs:{"d":"M3568.158-877.2h-.947v-1.8h-1.895v1.8h-7.579v-1.8h-1.895v1.8h-.947a1.855 1.855 0 00-1.895 1.8v12.6a1.855 1.855 0 001.895 1.8h8.526a5.6 5.6 0 01-1.421-1.8h-7.105v-9.9h13.263v2.34a4.7 4.7 0 011.895.63v-5.67a1.855 1.855 0 00-1.895-1.8m-.947 8.55a3.527 3.527 0 012.653 1.08l1.136-1.08v3.6h-3.789l1.705-1.62a2.806 2.806 0 00-1.705-.63 2.253 2.253 0 100 4.5 2.52 2.52 0 001.895-.9h1.611a3.819 3.819 0 01-7.295-1.35 3.709 3.709 0 013.789-3.6z","fill":"#fff"}})])])
          )
        }
      }
    